import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RawCountrySpecificSetting } from 'src/app/state-management/types/configuration.type';

export const MOCKED_COUNTRY_SPECIFIC_SETTINGS: RawCountrySpecificSetting[] = [
	{
		name: 'desktop_orientation_horizontal',
		value: 'right',
		settingType: 'Text',
	},
	{
		name: 'desktop_orientation_vertical',
		value: 'bottom',
		settingType: 'Text',
	},
	{
		name: 'mobile_orientation_horizontal',
		value: 'center',
		settingType: 'Text',
	},
	{
		name: 'mobile_orientation_vertical',
		value: 'top',
		settingType: 'Text',
	},
	{
		name: 'stack_toasts',
		value: 'true',
		settingType: 'Boolean',
	},
	{
		name: 'stack_toasts_display_max',
		value: '3',
		settingType: 'Number',
	},
	{
		name: 'links_myzeiss_inquiry',
		value: 'https://www.zeiss.com/vision-care/us/eye-care-professionals/myzeiss/my-enquiries.html',
		settingType: 'URL',
	},
	{
		name: 'visustore_link',
		value: 'https://q-live-vis.ecommerce.zeiss.com/login?seamlessSSO=true',
		settingType: 'URL',
	},
	{
		name: 'show_tc_of_sales',
		value: 'false',
		settingType: 'Boolean',
	},
	{
		name: 'order_reference_mandatory',
		value: 'true',
		settingType: 'Boolean',
	},
	{
		name: 'block_submit_order',
		value: 'false',
		settingType: 'Boolean',
	},
	{
		name: 'links_myzeiss',
		value: 'https://www.zeiss.com/vision-care/myzeiss',
		settingType: 'URL',
	},
	{
		name: 'academy_link',
		value: 'https://academy.com',
		settingType: 'URL',
	},
	{
		name: 'engraving',
		value: 'false',
		settingType: 'Boolean',
	},
	{
		name: 'order_reference_allow_special',
		value: '-#*',
		settingType: 'Text',
	},
	{
		name: 'data_privacy_note',
		value: 'https://www.zeiss.com/data-protection/us/home.html',
		settingType: 'URL',
	},
	{
		name: 'color_dot_mandatory',
		value: 'false',
		settingType: 'Boolean',
	},
	{
		name: 'show_order_reference',
		value: 'true',
		settingType: 'Boolean',
	},
	{
		name: 'show_modified_prescription',
		value: 'false',
		settingType: 'Boolean',
	},
	{
		name: 'data_privacy_tc',
		value: 'add.TermsAndConditions.com',
		settingType: 'URL',
	},
	{
		name: 'direct_shipment',
		value: 'false',
		settingType: 'Boolean',
	},
	{
		name: 'tc_of_sales_link',
		value: 'https://add.TermsOfSale.com',
		settingType: 'URL',
	},
	{
		name: 'show_myzeiss_inquiry',
		value: 'false',
		settingType: 'Boolean',
	},
	{
		name: 'myprofile_link',
		value: 'https://id.zeiss.com',
		settingType: 'URL',
	},
	{
		name: 'order_reference_max_length',
		value: '20',
		settingType: 'Number',
	},
	{
		name: 'color_dot',
		value: 'false',
		settingType: 'Boolean',
	},
	{
		name: 'order_reference_allow_numbers',
		value: 'true',
		settingType: 'Boolean',
	},
	{
		name: 'address_validation',
		value: 'AZURE',
		settingType: 'Select',
	},
	{
		name: 'engraving_mandatory',
		value: 'false',
		settingType: 'Boolean',
	},
	{
		name: 'date_time_format',
		value: 'DD.MM.YYYY 24:00:00',
		settingType: 'Text',
	},
	{
		name: 'myorders_link',
		value:
			'https://wwwinternet.zeiss.com/vision-care/us/eye-care-professionals/myzeiss/my-orders.html',
		settingType: 'URL',
	},
	{
		name: 'order_reference_allow_alphabetic',
		value: 'true',
		settingType: 'Boolean',
	},
	{
		name: 'address_suggestion',
		value: 'true',
		settingType: 'Boolean',
	},
	{
		name: 'allowed_contact_roles',
		value: '["12"]',
		settingType: 'MultiSelect',
	},
	{
		name: 'show_contact_person',
		value: 'true',
		settingType: 'Boolean',
	},
];

@Injectable()
export class ConfigurationServiceMock {
	private _mockedSettings: RawCountrySpecificSetting[] = MOCKED_COUNTRY_SPECIFIC_SETTINGS;

	fetchCountrySpecificSettings(): Observable<RawCountrySpecificSetting[]> {
		return new BehaviorSubject<RawCountrySpecificSetting[]>(this._mockedSettings);
	}

	public static createConfigurationServiceMock(mockedSettings: any) {
		const service = new ConfigurationServiceMock();
		service._mockedSettings = mockedSettings;
		return service;
	}
}
